import React from 'react';

import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';

import { CircularProgressWithLabel } from 'components/DesignSystem/CircularProgressWithLabel';

import classes from './SubmittedDurationCompleteCell.module.scss';

interface Props {
    value: unknown;
}

export const SubmittedDurationCompleteCell = ({ value }: Props) => {
    return (
        <div className={classes.submittedDurationCompleteCell}>
            <CustomizedTooltip
                tooltipContent={`Submitted Completion: ${value}%`}
                triggerElement={<CircularProgressWithLabel value={Number(value)} />}
            />
        </div>
    );
};
